module.exports = __webpack_public_path__ + "static/ControlEventsWite-4806a77ea91423de8297c8a1735c5be8.png";